import { Component } from "react";
import { toast } from "sonner";

const DEFAULT_SETTINGS = {
  heading_family: "Caught", body_family: "Space Grotesk", heading_scale: 1.0, body_size: 16,
  heading_weight: 500, body_weight: 400, letter_spacing: -0.02, heading_italic: false, heading_uppercase: false,
  container_max: 1280, section_padding_y: 48, card_padding: 24, card_radius: 16, border_width: 1.5,
  color_primary: "#670003", color_background: "#fff0d2", color_ink: "#141414",
};

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, count: 0 };
  }
  static getDerivedStateFromError() { return { hasError: true }; }
  componentDidCatch(error) {
    // Revert theme to last good (or defaults if none)
    try {
      const cached = JSON.parse(localStorage.getItem("settings_cache") || "null");
      const revert = cached || DEFAULT_SETTINGS;
      localStorage.setItem("settings_cache", JSON.stringify(revert));
      // eslint-disable-next-line no-console
      console.error("App crashed, reverting theme:", error);
      setTimeout(() => { toast?.error?.("Perubahan menyebabkan error. Pengaturan dikembalikan."); }, 300);
    } catch (_) { /* noop */ }
    // Auto reload after a beat to apply reverted theme
    if (this.state.count < 1) {
      setTimeout(() => { window.location.reload(); }, 800);
      this.setState((s) => ({ count: s.count + 1 }));
    }
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 40, textAlign: "center", fontFamily: "system-ui" }}>
          <h1 style={{ fontSize: 28, marginBottom: 8 }}>Memulihkan…</h1>
          <p style={{ color: "#666" }}>Pengaturan sedang dikembalikan.</p>
        </div>
      );
    }
    return this.props.children;
  }
}
